import classNames from "classnames";
import styles from "./Loading.module.css";
import LoadingSpinner from "./LoadingSpinner";

interface Props {
  fullHeight?: boolean;
}

const Loading = ({ fullHeight = false }: Props) => (
  <div
    className={classNames(styles.loading, {
      [styles["loading-full-height"]]: fullHeight,
    })}
  >
    <LoadingSpinner />
  </div>
);

export default Loading;
